import { useSearchParams } from 'react-router-dom';

import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import type { BannerMessageI } from 'declarations/interfaces/notifications';
import { useFetchBannerMessages } from 'hooks/api/useNotifications';

type UseBannerMessagesT = {
  bannerMessages: BannerMessageI[] | null;
  isLoadingBannerMessages: boolean;
  isFetchingBannerMessages: boolean;
};

const useBannerMessages = (): UseBannerMessagesT => {
  const [searchParams] = useSearchParams();
  const roofTopId = searchParams.get(TicketsRefinementKeysE.RoofTopId) || '';

  const bannerMessagesResult = useFetchBannerMessages({ roofTopId });

  return {
    bannerMessages: bannerMessagesResult.data ?? null,
    isLoadingBannerMessages: bannerMessagesResult.isLoading ?? false,
    isFetchingBannerMessages: bannerMessagesResult.isFetching ?? false,
  };
};

export default useBannerMessages;
